import React from "react";
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserInfo } from "../../app/store/userSlice";

const AuthRoute = ({ component: Component, ...rest }:any) => {
    const userinfo = useSelector(selectUserInfo);
    return (
        userinfo && userinfo.username ? <Route {...rest} render={(props) => (
            <Component {...props} />
        )} /> : <Redirect to='/login' />
    )
}

export default AuthRoute;